import { useEffect, useRef, useState } from "react"
import ProgressBar from "./ProgressBar"

interface Props {
    expected_time: number // seconds
    isLoading: boolean
    title: string | null
    subtitle: string | null
    reset_idx?: number // increment to reset the timer
}

const TimedProgressBar: React.FC<Props> = ({expected_time, isLoading, title, subtitle, reset_idx = 0}) => {
    const [progress, setProgress] = useState(0)
    const started = useRef(false)
    const startTime = useRef(0);
    const [quickLoad, setQuickLoad] = useState(true);

    useEffect(() => {
        if (started.current) return;
        started.current = true;

        const tick = () => {
            const timeTaken = performance.now() - startTime.current;
            const newProgress = timeTaken/(expected_time*1000);
            setProgress(newProgress)

            if (newProgress < 1)
                requestAnimationFrame(tick);
        }
        tick()

        // start showing progress bar only after some trial period
        // to avoid blinking if data loads quikly
        const quickLoadTimeout = 200; // ms
        setTimeout(() => {
            setQuickLoad(false);
        }, quickLoadTimeout)
    })

    useEffect(() => {
        startTime.current = performance.now();        
    }, [reset_idx])

    return (<ProgressBar progress={isLoading ? progress: 0} isLoading={isLoading && !quickLoad && progress < 1} title={title} subtitle={subtitle} smooth={false} />)
}

export default TimedProgressBar